/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 19/06/2019.
 */

export enum PageActionEnum {
    /**
     * NEW_PAGE.
     */
    NEW_PAGE = <any> 'NEW_PAGE',
    /**
     * NEW_SECTION.
     */
    NEW_SECTION = <any> 'NEW_SECTION'
}

